export default {
  // Your original product data
  googleTV: {
    name: "K350", // Display name for the button
    faqs: [
      {
        question: "How do I pair the remote control with the projector?",
        answer:
          "First, ensure batteries are installed in the remote. To pair, press and hold the ← and home buttons simultaneously more than three seconds near the projector. A pairing message will appear on the screen once successful.",
      },
      {
        question: "Why is my projector not connecting to Wi-Fi?",
        answer:
          "Ensure your Wi-Fi password is correct and you're within range of the router. Restart both the router and projector if the issue persists.",
      },
      {
        question:
          "Can I use Bluetooth headphones or speakers with this projector?",
        answer:
          "Yes! Go to Settings > Bluetooth, turn it on, and select your Bluetooth device from the list. Make sure your headphones/speakers are in pairing mode.",
      },
      {
        question: "Can I use this projector without an extra streaming stick?",
        answer:
          "Yes! This projector comes with Google TV and built-in Netflix, Prime Video, YouTube, and more. No additional device is needed—just plug in and stream.",
      },
      {
        question: "How can I log into Netflix, Prime Video, or YouTube?",
        answer:
          "From the Google TV home screen, select the app you'd like to use and log in with your account. For quick access, you can press the dedicated app buttons on the remote control or use voice control to open the app instantly.",
      },
      {
        question: "The screen looks blurry. How do I adjust the focus?",
        answer:
          "This projector supports auto focus. If the image is unclear, use the remote’s Focus button or go to Settings > Display > Focus Adjustment to fine-tune.",
      },
      {
        question: "How do I update the system or apps?",
        answer:
          "Go to Settings > System > About > System Update to check for firmware updates. Apps update automatically via the built-in Google Play Store.",
      },
      {
        question:
          "How do I wirelessly connect my iPhone or Android phone to the projector?",
        answer:
          "To mirror your phone screen, please open the Google Cast app on the projector and follow the prompts to install the Miracast plugin. This plugin is required for both iOS and Android devices and involve a paid version. For Android users, you can also cast directly via the built-in Google Cast feature. For iOS users, a third-party app that supports Miracast or AirPlay is needed. For the most stable connection, an HDMI adapter is recommended.",
      },
    ],
  },
  // Your new product data
  btRemoteProjector: {
    name: "W1K", // Display name for the button
    faqs: [
      {
        question: "How can I do if the image is blurry or out of shape?",
        answer: `
                Please try the following steps:
                <ul>
                  <li class='mt-2'>Adjust the focus by pressing the focus[ +]/[-] button till it shows the correct image.</li>
                  <li class='mt-2'>Place the projector on a flat surface horizontally or vertically. An inclination at any angle may result in blurry displays or uneven colors.</li>
                  <li class='mt-2'>A darker environment is suggested to achieve the best projecting performance.</li>
                  <li class='mt-2'>The best distance is 1.3-2.5m / 42.5inch - 82 inch between the projector and projecting screen/wall.</li>
                  <li class='mt-2'>Ensure the projecting wall or screen is clean and white if possible.</li>
                </ul>
              `,
      },
      {
        question: "How to pair the BT remote control with the projector?",
        answer:
          '1. Please ensure that the remote control is within 10 cm from the device.<br>2. Press the "Volume -" and “Volume +” buttons on the remote control at the same time until the remote control icon appears on the homepage.',
      },
      {
        question: "How does the projector connect via Bluetooth?",
        answer: `
                <strong>Output (Connecting to external devices like speakers/headsets):</strong>
                <ol class='mt-2 list-decimal list-inside'>
                  <li>Enter homepage and select "Settings".</li>
                  <li>Choose the corresponding BT device to connect.</li>
                </ol>
                <br>
                <strong>Input (Connecting to a mobile phone, using the projector as a speaker):</strong>
                 <ol class='mt-2 list-decimal list-inside'>
                  <li>Enter homepage and select “My apps", then choose Music-connecting.</li>
                  <li><strong>Tips:</strong> Please always keep on the connection page.</li>
                </ol>
              `,
      },
      {
        question:
          "Why it prompts that there is no network when entering the Android screen mirroring interface?",
        answer:
          'After entering the screen projection assistant, you can perform Android and iOS screen mirroring. Because Android is restricted by Microsoft code, it will display "no network" after entering Android screen mirroring.<br><br><strong>Ps:</strong> This is a normal phenomenon. Android does not need a network for screen mirroring. When you switch from Android mirroring to iOS mirroring or exit, WiFi will automatically re-pair for you (takes about 5-20s).',
      },
      {
        question: "How to screen mirror iOS devices to the projector?",
        answer: `
                <ol class='list-decimal list-inside'>
                  <li>Please select the projection assistant on the homepage.</li>
                  <li>Go to the iOS MagicCast and Select “Go to Download".</li>
                  <li>After successful download, use the Airplay feature to mirror any iPhone/iPad/Macbook using the same WiFi connection.</li>
                </ol>
              `,
      },
      {
        question: "How to mirror screen Android devices to the projector?",
        answer: `
                <ol class='list-decimal list-inside'>
                  <li>Please select the projection assistant on the homepage.</li>
                  <li>Select “Miracast".</li>
                  <li>Go to your Android device "Settings” and select your WLAN.</li>
                  <li>Activate the Multi-screen/Smart View/Wireless Display function in your Android device, search for the projector (e.g., “w1k”), and click to connect.</li>
                </ol>
              `,
      },
      {
        question:
          "The video cannot be mirrored. There is sound but no picture, or no sound and no picture.",
        answer: `
                1. Please note that copyrighted videos, such as those from "Amazon Prime", "YouTube”, “Hulu", “Netflix”, “Disney+” or other popular streaming services, cannot be mirrored on the same screen due to DRM (Digital Rights Management) protections. <br><strong>PS:</strong> You can try to play these services through a web browser on your device and mirror the browser tab.
                <br><br>
                2. Is the source resolution too high? (e.g., 4k, 8k) And is the video refresh rate exceeding 60Hz? Please note that the projector only supports up to 60Hz and the video source cannot exceed 1080p.
              `,
      },
    ],
  },
  H272: {
    name: "H272",
    faqs: [
      {
        question: "[Alexa] Q: What you need to get started？",
        answer: `A1: Before you can use the Roku skill for Alexa, make sure your Roku device is running Roku OS 9.1 or higher. You can find the software version by visiting Settings > System > About. Your Roku device checks for an update every 24-36 hours or you can manually check for a software update if needed.
In addition to a compatible Roku player or Roku TV system with the correct software, you will need the following:
A free Roku account
An Alexa-enabled device such as an Amazon Echo, Echo Show, Echo Dot, Echo Spot, Echo Plus, or third-party device with Amazon Alexa
Alexa mobile app downloaded to your iOS® or Android™ device`,
      },
      {
        question:
          "[Alexa] Q: How to set up Alexa on your Roku TV smart projector？",
        answer: `A1: To use the Roku skill for Alexa, you need to link your Roku account to your Amazon account using the following steps:
1.Open the Alexa mobile app
2.Tap or select the Menu icon in the corner
3.Tap Settings
4.Scroll to TV & Video and select Roku from the list
5.Tap the Enable button
6.A prompt is opened in a browser, sign in to your Roku account.
7.Select Accept and Continue, and follow the prompts to return to the Alexa app
8.Choose the Alexa devices you wish to use with your Roku devices
9.Select LINK DEVICES`,
      },
      {
        question: "[Alexa] Q: What you can do with Alexa？",
        answer: `A1: When you use the Roku skill for Alexa, you can:
Control media playback
Issue a command by saying "Alexa" followed by:
“pause on kitchen Roku”
“fast forward on living room Roku”
“rewind on bedroom Roku”
“launch Prime Video on den Roku”
“go home on office Roku”
Search for entertainment
Issue a command by saying "Alexa" followed by:
“find documentaries on bedroom Roku”
“show comedies on kitchen Roku”
Control your Roku TV system
Issue a command by saying "Alexa" followed by:
“turn on office Roku TV”
“raise the volume on living room Roku”
“mute on bedroom Roku”
“change to channel 7.1 on living room Roku”
“switch to HDMI 2 on kitchen Roku”`,
      },
      {
        question: "[Image] Q: How do I improve the image clarity?",
        answer: `A1: Auto Focus: You can move the projector or trigger auto focus by going to Home > Settings > Projector settings and selecting Start auto-focus.
Manual Focus: Go to Home > Settings > Projector settings > Image correction > Manual focus and follow the on-screen instructions to sharpen the image until it becomes clear.`,
      },
      {
        question: "[Image] Q:Couldn't complete auto-focus or auto-keystone?",
        answer: `A1: Ensure that nothing is obstructing the lens or the camera (located next to the brand name on the front side). Try adjusting the distance between the projector and the screen. If the issue persists, power off the projector, then turn it back on before attempting again.`,
      },
      {
        question: "[Image] Q:What should I do if the image is not rectangular?",
        answer: `A1: Auto Keystone Correction: Go to Home > Settings > Projector settings and select Start auto-keystone. The projector will automatically correct keystone distortion.
<br/>A2: Manual Keystone Correction: Go to Home > Settings > Projector settings > Image correction > Manual keystone and follow the on-screen instructions to adjust the image using four-point correction.`,
      },
    ],
  },
  H211E1: {
    name: "H211E1",
    faqs: [
      {
        question: `[HDMI Connection] Q: Why does the projector show "No Signal" when HDMI connects with phone?`,
        answer: `A1: Make sure all cables are plugged correctly and firmly.
<br/>A2: Please read the instructions of the HDMI adapter carefully before connecting.
<br/>A3: Please make sure to use an original cable, check the correct HDMI ports, or any damage of the cable.`,
      },
      {
        question:
          "[Streaming] Q: Why can't the projector play Netflix, Amazon Prime, or Hulu directly?",
        answer: `A1: Due to HDCP copyright restrictions, this mini projector does not support direct playback of Netflix, Amazon Prime Video, or Hulu.
<br/>A2: You can use an Amazon Fire Stick or Roku Stick to stream these applications normally.`,
      },
      {
        question: "[MAC] Q: No sound from the MAC connected projector?",
        answer: `A1: Select apple menu > system preferences, and then click sound. In the output panel, make sure your input is correctly selected.
<br/>A2: If you use the mini DisplayPort converter to connect, make sure your Mac can connect via mini DisplayPort sends audio.
<br/>A3: If you are connecting from the Mac mini, unplug any audio device that is connected to the computer audio output port.`,
      },
      {
        question:
          "[Display] Q: How should I do if there are small dots on display?",
        answer: `A1: Tap the projector slightly to shake off the dust which may be caused during installing or shipping.
<br/>A2: Clean the lens with clean non-woven fabrics. Try cleaning the projector. When cleaning the projector, you can dip it in alcohol.`,
      },
      {
        question:
          "[Shut Off] Q: Why does the projector is shut off during playing?",
        answer: `A1: Make sure the power plug is working and firmly fitted into the outlet.
<br/>A2: If the fan doesn't work when using it, please contact our customer service team for assistance.
<br/>A3: Overheat on the projector will activate built-in power-off protection panel. Restart the projector when it gets cooler.`,
      },
      {
        question:
          "[Image] Q: How can I do if the image is blurry or out of shape?",
        answer: `A1: Adjust the focus ring by moving it leftward/rightward till it shows the correct image.
A2: Place the projector on a flat surface horizontally or vertically. An inclination at any angle may result in blurry displays or uneven colors.
A3: Darker environment suggested achieving the best pro cine performance.
A4: The eligible distance of 2.63-13.12 feet between the projector and projecting screen/wall.
A5: Projecting wall or screen is clean white if possible.`,
      },
      {
        question:
          "[Audio] Q: Why is the audio of the projector available but without display?",
        answer: `A1: The video format is not supported by the projector.
<br/>A2: Encryption applied to the videos or media player which holds the video.
<br/>A3: If the lamp of the projector is off with only audio playing, the lamp is defective. Please contact our customer service team for a replacement.
<br/>A4: Try another HDMI cable if you select the HDMI Input Source.
<br/>A5: Try YouTube if your Screen mirroring player Netflix, Amazon Prime, Hulu and Disney+. The problem will happen when playing these applications because of copyright.`,
      },
      {
        question:
          "[Audio] Q: Why is the display of the projector available but without audio?",
        answer: `A1: The projector or the connected device (PC, TV, etc.) is muted.
<br/>A2: The video format is not supported by the projector.`,
      },
      {
        question:
          "[Remote Control] Q: What should I do if the remote control is lost or I need the IR code?",
        answer: `A1: Please contact our customer service team for support.
<br/>A2: We can provide a replacement remote control or IR code free of charge during the warranty period.`,
      },
    ],
  },
  H211: {
    name: "H211",
    faqs: [
      {
        question: "[Alexa] Q: What you need to get started？",
        answer: `A1: Before you can use the Roku skill for Alexa, make sure your Roku device is running Roku OS 9.1 or higher. You can find the software version by visiting Settings > System > About. Your Roku device checks for an update every 24-36 hours or you can manually check for a software update if needed.
In addition to a compatible Roku player or Roku TV system with the correct software, you will need the following:
A free Roku account
An Alexa-enabled device such as an Amazon Echo, Echo Show, Echo Dot, Echo Spot, Echo Plus, or third-party device with Amazon Alexa
Alexa mobile app downloaded to your iOS® or Android™ device`,
      },
      {
        question:
          "[Alexa] Q: How to set up Alexa on your Roku TV smart projector？",
        answer: `A1: To use the Roku skill for Alexa, you need to link your Roku account to your Amazon account using the following steps:
<li>1.Open the Alexa mobile app</li>
<li>2.Tap or select the Menu icon in the corner</li>
<li>3.Tap Settings</li>
<li>4.Scroll to TV & Video and select Roku from the list</li>
<li>5.Tap the Enable button</li>
<li>6.A prompt is opened in a browser, sign in to your Roku account.</li>
<li>7.Select Accept and Continue, and follow the prompts to return to the Alexa app</li>
<li>8.Choose the Alexa devices you wish to use with your Roku devices</li>
<li>9.Select LINK DEVICES</li>`,
      },
      {
        question: "[Alexa] Q: What you can do with Alexa？",
        answer: `A1: When you use the Roku skill for Alexa, you can:
Control media playback
Issue a command by saying "Alexa" followed by:
“pause on kitchen Roku”
“fast forward on living room Roku”
“rewind on bedroom Roku”
“launch Prime Video on den Roku”
“go home on office Roku”
Search for entertainment
Issue a command by saying "Alexa" followed by:
“find documentaries on bedroom Roku”
“show comedies on kitchen Roku”
Control your Roku TV system
Issue a command by saying "Alexa" followed by:
“turn on office Roku TV”
“raise the volume on living room Roku”
“mute on bedroom Roku”
“change to channel 7.1 on living room Roku”
“switch to HDMI 2 on kitchen Roku”`,
      },
      {
        question: "[Image] Q: How do I change the image size on my screen?",
        answer: `A1: Consider moving the projector closer or further away from the screen to find the optimal image size for the screen. You can also adjust the image size by going to Home > Settings > Projector settings > Image correction > Zoom.`,
      },
      {
        question:
          "[Mobile App] Q: How to install the Remote Control Mobile App?",
        answer: `A1: The free Roku app allows you to use your mobile device as a full functioning remote control with voice search & keypad.
① Download the Roku app to your phone or tablet through Google Play™ or Apple App Store™.
② Simply search for "Roku App" and choose the Roku app by Roku Inc.
③ Follow the on-screen prompts and you're on your way!`,
      },
      {
        question: "[Wi-Fi] Q:Cannot connect to a wireless network (Wi-Fi)?",
        answer: `A1: Select the correct wireless network name and verify the password entered (case sensitive).
Relocate the router from objects that interfere with performance (cordless phones, baby monitors, etc.).
Reboot the router by disconnecting the power for more than 2 minutes and reconnect.`,
      },
      {
        question: "[Remote Control] Q: Why doesn't the remote control work?",
        answer: `A1: Make sure the remote points at the IR receiver directly.
<br/>A2: Make sure you have installed two AAA batteries in the remote control.
A3: Avoid mixing new batteries with old ones in the remote control as this can result in insufficient power supply and operational issues.`,
      },
      {
        question:
          "[Shut Off] Q: What should I do if the projector fails to power on or automatically shuts down?",
        answer: `A1: Please check and ensure that the power cable is securely plugged into the power port to prevent any accidental disconnection or loosening when moving the projector.`,
      },
    ],
  },
};
